<template>
    <v-container id="adminmesasexafinal-ivt">
      <v-row class="text-center">
        <v-col cols="12">
          <v-card dark color="success" class="alineacentro Titulo TituloAlto">
            <v-card-text class="Titulo"
              ><strong>ADMINISTRACION DE MESAS DE EXÁMENES FINALES</strong></v-card-text
            >
          </v-card>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col>
          <v-spacer/>
        </v-col>
      </v-row>
      <v-row class="text-center">
        <v-tabs
          centered
          color="#4bc47f"
          dark
          icons-and-text
          v-model="tabactivo"
        >
          <v-tabs-slider color="#2a6bbf" />
          <v-tab
            href="#tab-1"
            key="Turnos"
          >
            Turnos
            <v-icon>mdi-calendar-month-outline</v-icon>
          </v-tab>
          <v-tab-item value="tab-1">
            <v-card flat>
              <v-card-text>
                <v-row row wrap>
                  <v-col cols="12" md="3" xl="3">
                    <v-select
                      v-model="filtros.anio"
                      :items="listaanios"
                      label="Año"
                      item-text="anio"
                      item-value="idanio"
                      v-on:change="actualizagrillaturnos"
                    />
                  </v-col>
                  <v-col cols="12" md="9" xl="9" class="alineaizquierda">
                    <v-btn
                      class="ma-2"
                      x-small
                      color="blue"
                      title="Listar Turnos"
                      @click="actualizagrillaturnos"
                    >
                      <v-icon dark> mdi-magnify</v-icon>
                    </v-btn>
                    <v-btn
                      class="ma-2"
                      x-small
                      color="blue"
                      title="Nuevo Turno"
                      @click="agregarturno"
                    >
                      <v-icon dark> mdi-plus</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row row wrap>
                  <v-col cols="12">
                    <v-card>
                      <v-card-title>
                        Turnos
                      </v-card-title>
                      <v-data-table
                        :headers="columnasturnos"
                        :items="listaturnos"
                        :items-per-page="10"
                        :footer-props="{
                            'items-per-page-text': 'Filas por Página:',
                            'items-per-page-all-text': 'Todos',
                        }"
                        item-key="idturno"
                        class="elevation-1"
                        dense
                        no-data-text="Sin Registros"
                        multi-sort
                      >
                        <template v-slot:item.actions="{ item }">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                small
                                icon
                                color="blue"
                                @click="editarturno(item)"
                                v-bind="attrs"
                                v-on="on"
                                :disabled="!item.permitemodificar"
                              >
                                <v-icon>mdi-pencil</v-icon>
                              </v-btn>
                            </template>
                            <span>Modificar Turno</span>
                          </v-tooltip>
                          &nbsp;
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                small
                                icon
                                color="green"
                                @click="quitarturno(item)"
                                v-bind="attrs"
                                v-on="on"
                                :disabled="!item.permiteeliminar"
                              >
                                <v-icon>mdi-delete</v-icon>
                              </v-btn>
                            </template>
                            <span>Eliminar Turno</span>
                          </v-tooltip>
                        </template>
                      </v-data-table>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab
            href="#tab-2"
            key="Mesas"
          >
            Mesas
            <v-icon>mdi-calendar-check-outline</v-icon>
          </v-tab>
          <v-tab-item value="tab-2">
            <v-card flat>
              <v-card-text>
                <v-row row wrap>
                  <v-col cols="12" md="3" xl="3">
                    <v-select
                      v-model="filtrosmesa.anio"
                      :items="listaanios"
                      label="Año"
                      item-text="anio"
                      item-value="idanio"
                      v-on:change="cargaturnosparamesas"
                    />
                  </v-col>
                  <v-col cols="12" md="3" xl="3">
                    <v-select
                      v-model="filtrosmesa.idturno"
                      :items="listaturnosfiltro"
                      label="Turno"
                      item-text="nombre"
                      item-value="idturno"
                      v-on:change="actualizagrillamesas"
                    />
                  </v-col>
                  <v-col cols="12" md="4" xl="4">
                    <v-select
                      v-model="filtrosmesa.idcarrera"
                      :items="listacarrerasfiltro"
                      label="Carrera"
                      item-text="carrera"
                      item-value="idcarrera"
                      v-on:change="actualizagrillamesas"
                    />
                  </v-col>
                  <v-col cols="12" md="2" xl="2" class="alineaizquierda">
                    <v-btn
                      class="ma-2"
                      x-small
                      color="blue"
                      title="Listar Mesas"
                      @click="actualizagrillamesas"
                      :disabled="filtrosmesa.idcarrera===0 || filtrosmesa.idturno===0"
                    >
                      <v-icon dark> mdi-magnify</v-icon>
                    </v-btn>
                    <v-btn
                      class="ma-2"
                      x-small
                      color="blue"
                      title="Nuevo Mesa"
                      @click="agregarmesa"
                      :disabled="filtrosmesa.idcarrera===0 || filtrosmesa.idturno===0"
                    >
                      <v-icon dark> mdi-plus</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row row wrap>
                  <v-col cols="12">
                    <v-card>
                      <v-card-title>
                        Mesas de Exámenes Finales
                      </v-card-title>
                      <v-data-table
                        :headers="columnasmesas"
                        :items="listamesas"
                        :items-per-page="10"
                        :footer-props="{
                            'items-per-page-text': 'Filas por Página:',
                            'items-per-page-all-text': 'Todos',
                        }"
                        item-key="idmesaexamen"
                        class="elevation-1"
                        dense
                        no-data-text="Sin Registros"
                        multi-sort
                      >
                        <template v-slot:item.actions="{ item }">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                small
                                icon
                                color="blue"
                                @click="editarmesa(item)"
                                v-bind="attrs"
                                v-on="on"
                                v-show="item.permitemodificar"
                              >
                                <v-icon>mdi-pencil</v-icon>
                              </v-btn>
                            </template>
                            <span>Modificar Mesa</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <span v-show="item.permiteanular">&nbsp;</span>
                              <v-btn
                                small
                                icon
                                color="red"
                                @click="anularmesa(item)"
                                v-bind="attrs"
                                v-on="on"
                                v-show="item.permiteanular"
                              >
                                <v-icon>mdi-delete</v-icon>
                              </v-btn>
                            </template>
                            <span>Anular Mesa</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <span v-show="item.permiteactivar">&nbsp;</span>
                              <v-btn
                                small
                                icon
                                color="green"
                                @click="activarmesa(item)"
                                v-bind="attrs"
                                v-on="on"
                                v-show="item.permiteactivar"
                              >
                                <v-icon>mdi-check</v-icon>
                              </v-btn>
                            </template>
                            <span>Activar Mesa</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <span v-show="item.permitecalificar">&nbsp;</span>
                              <v-btn
                                small
                                icon
                                color="violet"
                                @click="calificarmesa(item)"
                                v-bind="attrs"
                                v-on="on"
                                v-show="item.permitecalificar"
                              >
                                <v-icon>mdi-numeric</v-icon>
                              </v-btn>
                            </template>
                            <span>Calificar Mesa</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <span v-show="item.permitecerrar">&nbsp;</span>
                              <v-btn
                                small
                                icon
                                color="orange"
                                @click="cerrarmesa(item)"
                                v-bind="attrs"
                                v-on="on"
                                v-show="item.permitecerrar"
                              >
                                <v-icon>mdi-progress-close</v-icon>
                              </v-btn>
                            </template>
                            <span>Cerrar Mesa</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <span v-show="item.permiteimprimir">&nbsp;</span>
                              <v-btn
                                small
                                icon
                                color="seagreen"
                                @click="imprimiracta(item)"
                                v-bind="attrs"
                                v-on="on"
                                v-show="item.permiteimprimir"
                              >
                                <v-icon>mdi-printer</v-icon>
                              </v-btn>
                            </template>
                            <span>Imprimir Acta Volante</span>
                          </v-tooltip>
                        </template>
                      </v-data-table>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-row>
      <v-dialog v-model="dialogmensaje" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">
            {{ mensajetitulo }}
          </v-card-title>
          <v-card-text>
            {{ mensajecuerpo }}
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="green darken-1" text @click="dialogmensaje = false; if(mensajehome===true){$router.push('Home')}">
                Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="loading" full-width>
        <v-container
          fluid
          class="full-height"
          style="background-color: rgba(255, 255, 255, 0.5)"
        >
          <v-row
            align="center"
            justify="center"
            style="height: 100vh"
            no-gutters
            dense
          >
            <v-col class="elementocentrado">
            <v-progress-circular indeterminate color="primary" />
            </v-col>
          </v-row>
        </v-container>
      </v-dialog>
      <v-dialog v-model="dialognuevoturno" fullscreen>
        <v-card>
          <v-card-title class="headline">
            {{dialognuevoturnotitulo}}
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="guardarturno">
                    Guardar
                </v-btn>
                <v-btn
                    color="red darken-1"
                    text
                    @click="dialognuevoturno = false"
                >
                    Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <br/>
            <br/>
            <v-row row wrap>
              <v-col cols="12" md="3" xl="3">
                <v-select
                  v-model="turnoedited.anio"
                  :items="listaanios"
                  label="Año"
                  item-text="anio"
                  item-value="idanio"
                />
              </v-col>
              <v-col cols="12" md="3" xl="3">
                <v-select
                  v-model="turnoedited.idtipoturno"
                  :items="listatiposturno"
                  label="Tipo"
                  item-text="nombre"
                  item-value="idtipoturno"
                />
              </v-col>
              <v-col cols="12" md="3" xl="3">
                <v-menu
                  v-model="menufecturnodesde"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechalocalfturnodesde"
                      label="Desde"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="turnoedited.desde"
                    @input="menufecturnodesde = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="3" xl="3">
                <v-menu
                  v-model="menufecturnohasta"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechalocalfturnohasta"
                      label="Hasta"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="turnoedited.hasta"
                    @input="menufecturnohasta = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12" md="8" xl="8">
                <v-text-field
                  v-model="turnoedited.nombre"
                  label="Nombre"
                />
              </v-col>
              <v-col cols="12" md="4" xl="4">
                <v-text-field
                  v-model="turnoedited.resolucion"
                  label="Resolución"
                />
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12" md="3" xl="3">
                <v-text-field
                  v-model="turnoedited.horascorteparainscripcion"
                  label="Hs Corte Inscripción"
                  type="number"
                />
              </v-col>
              <v-col cols="12" md="3" xl="3">
                <v-text-field
                  v-model="turnoedited.horasanularinscripcion"
                  label="Hs Anulación Inscripción"
                  type="number"
                />
              </v-col>
              <v-col cols="12" md="3" xl="3">
                <v-text-field
                  v-model="turnoedited.llamados"
                  label="Cant. Llamados"
                  type="number"
                />
              </v-col>
              <v-col cols="12" md="3" xl="3">
                <v-select
                  v-model="turnoedited.idestado"
                  :items="listaestadosturno"
                  label="Estado"
                  item-text="nombre"
                  item-value="idestado"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialognuevamesa" fullscreen>
        <v-card>
          <v-card-title class="headline">
            {{dialognuevamesatitulo}}
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="guardarmesa">
                    Guardar
                </v-btn>
                <v-btn
                    color="red darken-1"
                    text
                    @click="dialognuevamesa = false"
                >
                    Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <br/>
            <br/>
            <v-row row wrap>
              <v-col cols="12" md="4" xl="4">
                <v-select
                  v-model="mesaedited.llamado"
                  :items="listallamados"
                  label="LLamado"
                  item-text="llamado"
                  item-value="llamado"
                />
              </v-col>
              <v-col cols="12" md="4" xl="4">
                <v-menu
                  v-model="menufecmesa"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechalocalfmesa"
                      label="Fecha"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="mesaedited.fecha"
                    @input="menufecmesa = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="4" xl="4">
                <v-menu
                  v-model="menuvenmesa"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechalocalvenmesa"
                      label="Vencimiento"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="mesaedited.vencimiento"
                    @input="menuvenmesa = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12">
                <v-select
                  v-model="mesaedited.idasignatura"
                  :items="listaasignaturas"
                  label="Asignatura"
                  item-text="nombre"
                  item-value="idasignatura"
                />
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12" md="4" xl="4">
                <v-select
                  v-model="mesaedited.idpresidente"
                  :items="listadocentes"
                  label="Presidente"
                  item-text="docente"
                  item-value="iddocente"
                />
              </v-col>
              <v-col cols="12" md="4" xl="4">
                <v-select
                  v-model="mesaedited.idvocal1"
                  :items="listadocentes"
                  label="Vocal 1"
                  item-text="docente"
                  item-value="iddocente"
                />
              </v-col>
              <v-col cols="12" md="4" xl="4">
                <v-select
                  v-model="mesaedited.idvocal2"
                  :items="listadocentes"
                  label="Vocal 2"
                  item-text="docente"
                  item-value="iddocente"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogcalificar" fullscreen>
        <v-card>
          <v-card-title class="headline">
            Calificaciones de la Mesa de Examen Final
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="guardacalificacion">
                    Guardar
                </v-btn>
                <v-btn
                    color="red darken-1"
                    text
                    @click="dialogcalificar = false"
                >
                    Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <br/>
            <br/>
            <v-card>
              <v-card-subtitle>
                <p class="TituloGrillaNormal">Carrera: {{calificaextras.carrera}}
                   &nbsp;&nbsp;
                   Turno: {{calificaextras.turno}}
                   &nbsp;&nbsp;
                   Llamado: {{calificaextras.llamado}}
                </p>
              </v-card-subtitle>
              <v-card-subtitle>
                <p class="TituloGrillaNormal">Asignatura: {{calificaextras.asignatura}}
                    &nbsp;&nbsp;
                   Fecha: {{calificaextras.fecha}}
                </p>
              </v-card-subtitle>
              <v-card-text>
                <v-row row wrap>
                  <v-col cols="12">
                    <v-data-table
                      :headers="columnasfinales"
                      :items="listafinales"
                      :items-per-page="10"
                      :footer-props="{
                        'items-per-page-text': 'Filas por Página:',
                        'items-per-page-all-text': 'Todos',
                      }"
                      item-key="idalumno"
                      class="elevation-1"
                      dense
                      no-data-text="Sin Registros"
                      multi-sort
                    >
                    <!-- <template v-slot:item.notaescrito="{ item }">
                        <v-text-field
                        v-model="item.notaescrito"
                        label="Escrito"
                        type="number"
                        class="alineacentro"
                        />
                    </template>
                    <template v-slot:item.notaoral="{ item }">
                        <v-text-field
                        v-model="item.notaoral"
                        label="Oral"
                        type="number"
                        class="alineacentro"
                        />
                    </template> -->
                      <template v-slot:item.notafinal="{ item }">
                        <v-text-field
                          v-model="item.notafinal"
                          label="Final"
                          type="number"
                          class="alineacentro"
                        />
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>
      </v-dialog>
      <ConfirmDlg ref="confirm" />
    </v-container>
</template>
<script>
  import axios from "@/axios";
  import ConfirmDlg from "../Confirm.vue";
  export default {
    name: "adminmesasexafinal",
    components: {
      ConfirmDlg: ConfirmDlg
    },
    data() {
      return {
        loading: false,
        usuario: '',
        permisolectura: false,
        permisoescritura: false,
        nromodulo: 15,
        dialogmensaje: false,
        mensajetitulo: '',
        mensajecuerpo: '',
        mensajehome: false,
        tabactivo: 'Turnos',
        listaanios: [],
        filtros: {
          anio: (new Date()).getFullYear()
        },
        columnasturnos: [
          {
            text: 'Op.',
            value: 'actions',
            sortable: false,
            width: 30
          },
          {
            text: "ID",
            align: "center",
            sortable: true,
            value: "idturno",
            width: 40
          },
          {
            text: "Tipo",
            align: "center",
            sortable: true,
            value: "tipoturno",
            width: 100
          },
          {
            text: "Nombre",
            align: "center",
            sortable: true,
            value: "nombre",
            width: 120
          },
          {
            text: "Desde",
            align: "center",
            sortable: true,
            value: "desdestr",
            width: 85
          },
          {
            text: "Hasta",
            align: "center",
            sortable: true,
            value: "hastastr",
            width: 85
          },
          {
            text: "Llamados",
            align: "center",
            sortable: true,
            value: "cantidadllamados",
            width: 80
          },
          {
            text: "Estado",
            align: "center",
            sortable: true,
            value: "estado",
            width: 90
          }
        ],
        listaturnos: [],
        buscaturno: '',
        dialognuevoturno: false,
        dialognuevoturnotitulo:'',
        listatiposturno: [],
        turnoedited: {
            idturno: 0,
            anio: (new Date()).getFullYear(),
            idtipoturno: 1,
            desde: '',
            hasta: '',
            nombre: '',
            resolucion: '',
            horascorteparainscripcion: 48,
            horasanularinscripcion: 24,
            llamados: 2,
            idestado: 1,
            usuario: ''
        },
        menufecturnodesde: false,
        menufecturnohasta: false,
        listaestadosturno: [],
        columnasmesas: [
          {
            text: 'Op.',
            value: 'actions',
            sortable: false,
            width: 120
          },
          {
            text: "ID",
            align: "center",
            sortable: true,
            value: "idmesaexamen",
            width: 40
          },
          {
            text: "Llamado",
            align: "center",
            sortable: true,
            value: "llamado",
            width: 70
          },
          {
            text: "Fecha",
            align: "center",
            sortable: true,
            value: "fechadmy",
            width: 80
          },
          {
            text: "Carrera",
            align: "center",
            sortable: true,
            value: "carrera",
            width: 70
          },
          {
            text: "Ciclo",
            align: "center",
            sortable: true,
            value: "ciclo",
            width: 65
          },
          {
            text: "Asignatura",
            align: "center",
            sortable: true,
            value: "asignatura",
            width: 120
          },
          {
            text: "Presidente",
            align: "center",
            sortable: true,
            value: "presidente",
            width: 120
          },
          {
            text: "Vencim",
            align: "center",
            sortable: true,
            value: "vencimientodmy",
            width: 80
          },
          {
            text: "Insc",
            align: "center",
            sortable: true,
            value: "inscriptos",
            width: 60
          },
          {
            text: "Calif",
            align: "center",
            sortable: true,
            value: "calificados",
            width: 65
          },
          {
            text: "Estado",
            align: "center",
            sortable: true,
            value: "estado",
            width: 90
          }
        ],
        listamesas: [],
        filtrosmesa: {
          anio: (new Date()).getFullYear(),
          idturno: 0,
          idcarrera: 0
        },
        listaturnosfiltro: [],
        listacarrerasfiltro: [],
        dialognuevamesa: false,
        dialognuevamesatitulo: '',
        menufecmesa: false,
        menuvenmesa: false,
        mesaedited: {
          idmesa: 0,
          idturno: 0,
          llamado: 0,
          fecha: '',
          vencimiento: '',
          idasignatura: 0,
          idpresidente: 0,
          idvocal1: 0,
          idvocal2: 0,
          usuario: ''
        },
        listaasignaturas: [],
        listadocentes: [],
        listallamados: [
          {llamado: 1},
          {llamado: 2}
        ],
        dialogcalificar: false,
        columnasfinales: [
          {
            text: "Orden",
            align: "center",
            sortable: true,
            value: "orden",
            width: 50
          },
          {
            text: "DNI",
            align: "center",
            sortable: true,
            value: "dnialumno",
            width: 50
          },
          {
            text: "Estudiante",
            align: "left",
            sortable: true,
            value: "alumno",
            width: 250
          },
          {
            text: "Año",
            align: "center",
            sortable: true,
            value: "anio",
            width: 70
          },
          /* {
            text: "Escrito",
            align: "center",
            sortable: true,
            value: "notaescrito",
            width: 70
          },
          {
            text: "Oral",
            align: "center",
            sortable: true,
            value: "notaoral",
            width: 70
          }, */
          {
            text: "Final",
            align: "center",
            sortable: true,
            value: "notafinal",
            width: 70
          }
        ],
        listafinales: [],
        calificaextras: {
          carrera: '',
          turno: '',
          llamado: '',
          asignatura: '',
          fecha: '',
          idmesa: 0
        }
      }
    },
    mounted() {
      this.loading=true;
      this.usuario= localStorage.getItem('user')
      var permisos= JSON.parse(localStorage.getItem('permisos'));
      var idrol= localStorage.getItem('rolusuario')
      var existeper=permisos.filter(p=> p.nromodulo===this.nromodulo && (p.idrol===idrol || p.usuario===this.usuario));
      if(existeper.length===0)
      {
        this.loading=false;
        this.mostrarmensaje('Error','No tiene permisos para acceder a este módulo.',true);
      }else{
        this.completacombos();
        //this.loading=false;
      }
    },
    methods: {
      mostrarmensaje(titulo, cuerpo, home) {
        this.mensajetitulo = titulo;
        this.mensajecuerpo = cuerpo;
        this.mensajehome= home!=null ? home : false;
        this.dialogmensaje = true;
      },
      completacombos () {
        this.loading=true;
        var anioactual=(new Date()).getFullYear();
        var inicio=2022;
        for(inicio=2022;inicio<=anioactual;inicio++){
          this.listaanios.push({idanio: inicio, anio: inicio});
        }
        axios.get('referenciales/tipoturnoexafinal').then((result) => {
          this.listatiposturno = result.data.datos;
          axios.get('referenciales/estadoturnoexafinal').then((result) => {
            this.listaestadosturno = result.data.datos;
            var parametroscarrera= JSON.stringify({iddocente: 0});
            axios.post("referenciales/PostCarreras",parametroscarrera, { headers: { "Content-Type": "application/json"}}).then((result) => {
              if(result.data.resultado===0){
                this.listacarrerasfiltro = result.data.datos.filter(c=> c.idnivel===4);
                this.filtrosmesa.idcarrera= this.listacarrerasfiltro.length>0 ? this.listacarrerasfiltro[0].idcarrera : 0;
                this.actualizagrillaturnos(true);
              }else{
                this.loading = false;
                this.MostrarMensaje('Error', result.data.resultadomensaje, false);
              }
            }).catch((error) => {
              this.loading = false;
              this.MostrarMensaje('Error', error, false);
            });
          }).catch((error) => {
            this.loading = false;
            this.mostrarmensaje('Error', error, false);
          })
        }).catch((error) => {
          this.loading = false;
          this.mostrarmensaje('Error', error, false);
        })
      },
      actualizagrillaturnos (actualizaturnosencombomesas) {
        this.loading=true;
        axios.get('examenfinal/ListaTurnos/' + this.usuario + '/' + this.filtros.anio.toString() + '/0').then((result) => {
          if(result.data.resultado===0)
          {
            this.listaturnos = result.data.datos;
            if(actualizaturnosencombomesas===true){
              this.cargaturnosparamesas();
            }else{
              this.loading = false;
            }
          }else{
            this.loading = false;
            this.mostrarmensaje('Error', result.data.resultadomensaje, false);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.mostrarmensaje('Error', error, false);
        })
      },
      agregarturno () {
        this.loading=true;
        this.dialognuevoturnotitulo='NUEVO TURNO DE EXAMEN FINAL';
        this.turnoedited= {
            idturno: 0,
            anio: (new Date()).getFullYear(),
            idtipoturno: 1,
            desde: '',
            hasta: '',
            nombre: '',
            resolucion: '',
            horascorteparainscripcion: 48,
            horasanularinscripcion: 24,
            llamados: 2,
            idestado: 1,
            usuario: this.usuario
        };
        this.dialognuevoturno= true;
        this.loading=false;
      },
      editarturno (item) {
        this.loading=true;
        this.dialognuevoturnotitulo='EDITANDO EL TURNO DE EXAMEN FINAL N° ' + item.idturno;
        this.turnoedited= {
            idturno: item.idturno,
            anio: item.año,
            idtipoturno: item.idtipoturno,
            desde: item.desdeymdstr,
            hasta: item.hastaymdstr,
            nombre: item.nombre,
            resolucion: item.resolucionnota,
            horascorteparainscripcion: item.horasanteriorparainscripcion,
            horasanularinscripcion: item.horasanteriorparaanularinscripcion,
            llamados: item.cantidadllamados,
            idestado: item.idestado,
            usuario: this.usuario
        };
        this.dialognuevoturno= true;
        this.loading=false;
      },
      async quitarturno (item) {
        if (await this.$refs.confirm.open("Eliminar Turno", "Está seguro que desea eliminar el turno?")) {
          this.loading = true;
          var turno = { idturno: item.idturno, usuario: this.usuario };
          axios.put("examenfinal/PutEliminarTurno", turno, { headers: { "Content-Type": "application/json"},}).then((result) => {
            if (result.data.resultado === 0) {
              this.actualizagrillaturnos();
            } else {
              this.loading = false;
              this.MostrarMensaje("Error", result.data.resultadomensaje, false);
            }
          }).catch((error) => {
            this.loading = false;
            this.MostrarMensaje("Error", error, false);
          });
        }
      },
      guardarturno () {
        this.loading=true;
        this.turnoedited.llamados= parseInt(this.turnoedited.llamados);
        this.turnoedited.horascorteparainscripcion= parseInt(this.turnoedited.horascorteparainscripcion);
        this.turnoedited.horasanularinscripcion= parseInt(this.turnoedited.horasanularinscripcion);
        const turno = JSON.stringify(this.turnoedited);
        axios.post("examenfinal/PostTurno", turno, { headers: {"Content-Type": "application/json", }}).then((result) => {
          if (result.data.resultado === 0) {
            this.dialognuevoturno= false;
            this.actualizagrillaturnos(true);
          }else{
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadomensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
      },
      actualizagrillamesas () {
        this.loading=true;
        axios.get('examenfinal/ListaMesasFinales/' + this.usuario + '/' + this.filtrosmesa.anio.toString() + '/' + this.filtrosmesa.idturno.toString()).then((result) => {
          if(result.data.resultado===0)
          {
            this.listamesas = result.data.datos;
            this.loading = false;
          }else{
            this.loading = false;
            this.mostrarmensaje('Error', result.data.resultadomensaje, false);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.mostrarmensaje('Error', error, false);
        })
      },
      cargaturnosparamesas() {
        axios.get('examenfinal/ListaTurnos/' + this.usuario + '/' + this.filtrosmesa.anio.toString() + '/0').then((result) => {
          if(result.data.resultado===0)
          {
            this.listaturnosfiltro = result.data.datos;
            if(this.listaturnosfiltro.length>0){
              this.filtrosmesa.idturno= this.listaturnosfiltro[0].idturno;
            }
            this.loading = false;
          }else{
            this.loading = false;
            this.mostrarmensaje('Error', result.data.resultadomensaje, false);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.mostrarmensaje('Error', error, false);
        })
      },
      agregarmesa () {
        var parametros= JSON.stringify({idcarrera: this.filtrosmesa.idcarrera, anio: 0 });
        axios.post("examenfinal/PostDocentesxAnioCarrera",parametros, { headers: { "Content-Type": "application/json"}}).then((result) => {
          if(result.data.resultado===0) {
            this.listadocentes = result.data.datos;
            var parametros= JSON.stringify({idcarrera: this.filtrosmesa.idcarrera, iddocente: 0, anio: 0 });
            axios.post("cursada/PostAsignaturas",parametros, { headers: { "Content-Type": "application/json"}}).then((result) => {
              if(result.data.resultado===0) {
                this.listaasignaturas = result.data.datos;
                this.mesaedited= {
                  idmesa: 0,
                  idturno: this.filtrosmesa.idturno,
                  llamado: 1,
                  fecha: this.fechaFormatoYMD(new Date()),
                  vencimiento: this.fechaFormatoYMD(new Date()),
                  idasignatura: this.listaasignaturas.length>0 ? this.listaasignaturas[0].idasignatura : 0,
                  idpresidente: 0,
                  idvocal1: 0,
                  idvocal2: 0,
                  usuario: this.usuario
                };
                this.dialognuevamesatitulo='Nueva Mesa de Exámen Final';
                this.dialognuevamesa= true;
                this.loading = false;
              }else{
                this.loading = false;
                this.MostrarMensaje('Error', result.data.resultadomensaje, false);
              }
            }).catch((error) => {
              this.loading = false;
              this.MostrarMensaje('Error', error, false);
            });
          }else{
            this.loading = false;
            this.MostrarMensaje('Error', result.data.resultadomensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje('Error', error, false);
        });
      },
      editarmesa (item) {
        var parametros= JSON.stringify({idcarrera: this.filtrosmesa.idcarrera, anio: 0 });
        axios.post("examenfinal/PostDocentesxAnioCarrera",parametros, { headers: { "Content-Type": "application/json"}}).then((result) => {
          if(result.data.resultado===0) {
            this.listadocentes = result.data.datos;
            var parametros= JSON.stringify({idcarrera: this.filtrosmesa.idcarrera, iddocente: 0, anio: 0 });
            axios.post("cursada/PostAsignaturas",parametros, { headers: { "Content-Type": "application/json"}}).then((result) => {
              if(result.data.resultado===0) {
                this.listaasignaturas = result.data.datos;
                this.mesaedited= {
                  idmesa: item.idmesaexamen,
                  idturno: item.idturno,
                  llamado: item.llamado,
                  fecha: item.fechaymd,
                  vencimiento: item.vencimientoymd,
                  idasignatura: item.idasignatura,
                  idpresidente: item.idpresidente,
                  idvocal1: item.idvocal1!=null ? item.idvocal1 : 0,
                  idvocal2: item.idvocal2!=null ? item.idvocal2 : 0,
                  usuario: this.usuario
                };
                this.dialognuevamesatitulo='Editando Mesa de Exámen Final ID: ' + item.idmesaexamen;
                this.dialognuevamesa= true;
                this.loading = false;
              }else{
                this.loading = false;
                this.MostrarMensaje('Error', result.data.resultadomensaje, false);
              }
            }).catch((error) => {
              this.loading = false;
              this.MostrarMensaje('Error', error, false);
            });
          }else{
            this.loading = false;
            this.MostrarMensaje('Error', result.data.resultadomensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje('Error', error, false);
        });
      },
      guardarmesa () {
        var valido= '';
        valido= this.validarmesa();
        if(valido.length===0) {
          this.loading=true;
          this.mesaedited.idvocal1 = this.mesaedited.idvocal1!=null ? this.mesaedited.idvocal1 : 0;
          this.mesaedited.idvocal2 = this.mesaedited.idvocal2!=null ? this.mesaedited.idvocal2 : 0;
          const mesa = JSON.stringify(this.mesaedited);
          axios.post("examenfinal/PostMesa", mesa, { headers: {"Content-Type": "application/json", }}).then((result) => {
            if (result.data.resultado === 0) {
              this.dialognuevamesa= false;
              this.actualizagrillamesas(true);
            }else{
              this.loading = false;
              this.MostrarMensaje("Error", result.data.resultadomensaje, false);
            }
          }).catch((error) => {
            this.loading = false;
            this.MostrarMensaje("Error", error, false);
          });
        }else{
          this.loading = false;
          this.MostrarMensaje("Error", valido, false);
        }
      },
      validarmesa () {
        var valido='';
        if(this.mesaedited.fecha===null || this.mesaedited.fecha==='') {
          valido= 'Debe ingresar fecha de la mesa';
        }
        if(this.mesaedited.vencimiento===null || this.mesaedited.vencimiento==='') {
          valido= 'Debe ingresar fecha de vencimiento de inscripción a la mesa';
        }
        if(this.mesaedited.idpresidente===null || this.mesaedited.idpresidente===0) {
          valido= 'Debe ingresar fecha de vencimiento de inscripción a la mesa';
        }
        return valido;
      },
      async anularmesa (item) {
        var pregunta='';
        var titulo= '';
        if(item.idestado===1){
          titulo= 'Confirmar Borrado de la Mesa';
          pregunta= "Esta seguro de querer borrar la mesa ID " + item.idmesaexamen.toString() + " ?";
        }else{
          titulo= 'Confirmar Anulación de la Mesa';
          pregunta= "Esta seguro de querer anular la mesa ID " + item.idmesaexamen.toString() + " ?";
        }
        if (await this.$refs.confirm.open(titulo, pregunta)) {
            const mesa = JSON.stringify({idmesa: item.idmesaexamen, usuario: this.usuario});
            axios.post("examenfinal/PostAnulaMesa", mesa, { headers: {"Content-Type": "application/json", }}).then((result) => {
              if (result.data.resultado === 0) {
                this.actualizagrillamesas();
              }else{
                this.loading = false;
                this.MostrarMensaje("Error", result.data.resultadomensaje, false);
              }
            }).catch((error) => {
              this.loading = false;
              this.MostrarMensaje("Error", error, false);
            });
          }
      },
      async activarmesa (item) {
        if (await this.$refs.confirm.open('Activar Mesa', 'Esta seguro de activar la mesa de examen? los alumnos podran verla e inscribirse a partir de la fecha de inicio del turno.')) {
            const mesa = JSON.stringify({idmesa: item.idmesaexamen, usuario: this.usuario});
            axios.post("examenfinal/PostActivarMesa", mesa, { headers: {"Content-Type": "application/json", }}).then((result) => {
              if (result.data.resultado === 0) {
                this.actualizagrillamesas();
              }else{
                this.loading = false;
                this.MostrarMensaje("Error", result.data.resultadomensaje, false);
              }
            }).catch((error) => {
              this.loading = false;
              this.MostrarMensaje("Error", error, false);
            });
          }
      },
      calificarmesa (item) {
        this.loading=true;
        var parametros= JSON.stringify({ idmesa: item.idmesaexamen, usuario: this.usuario });
        axios.post("examenfinal/PostListaFinales",parametros, { headers: { "Content-Type": "application/json"}}).then((result) => {
          if(result.data.resultado===0) {
            this.calificaextras= {
                carrera: item.carrera,
                turno: item.turno,
                llamado: item.llamado,
                asignatura: item.asignatura,
                fecha: item.fechadmy,
                idmesa: item.idmesaexamen
            };
            this.listafinales = result.data.datos;
            this.dialogcalificar= true;
            this.loading = false;
          }else{
            this.loading = false;
            this.MostrarMensaje('Error', result.data.resultadomensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje('Error', error, false);
        });
      },
      guardacalificacion () {
        var valido=this.validarfinales();
        if(valido.length===0) {
          this.loading=true;
          const finales = JSON.stringify({idmesa: this.calificaextras.idmesa, finales: this.listafinales, usuario: this.usuario });
          axios.post("examenfinal/PostCalificar", finales, { headers: {"Content-Type": "application/json", }}).then((result) => {
            if (result.data.resultado === 0) {
              this.dialogcalificar= false;
              this.actualizagrillamesas(true);
            }else{
              this.loading = false;
              this.MostrarMensaje("Error", result.data.resultadomensaje, false);
            }
          }).catch((error) => {
            this.loading = false;
            this.MostrarMensaje("Error", error, false);
          });
        }
      },
      validarfinales () {
        var res='';
        return res;
      },
      async cerrarmesa (item) {
        if (await this.$refs.confirm.open('Cerrar Mesa', 'Esta seguro de cerrar la mesa de examen? Ya no podran hacer modificaciones en los datos ni en las calificaciones.')) {
            const mesa = JSON.stringify({idmesa: item.idmesaexamen, usuario: this.usuario});
            axios.post("examenfinal/PostCerrarMesa", mesa, { headers: {"Content-Type": "application/json", }}).then((result) => {
              if (result.data.resultado === 0) {
                this.actualizagrillamesas();
              }else{
                this.loading = false;
                this.MostrarMensaje("Error", result.data.resultadomensaje, false);
              }
            }).catch((error) => {
              this.loading = false;
              this.MostrarMensaje("Error", error, false);
            });
        }
      },
      imprimiracta (item) {
        this.loading = true;
        axios.post("reportes/GetReporte", {idreporte: 10, formato: 'PDF', listaparametros: [{ orden: 1, nombre: "idmesa", valor: item.idmesaexamen.toString()} ] },{ headers: { "Content-Type": "application/json" }}).then((result) => {
          this.loading = false;
          if (result.data.toString().startsWith("Error") === false) {
            if(item.idestado<5){
              this.loading = false;
              window.open(result.data, "_blank");
            }else{
              this.preguntamarcaimpresion(result.data, item.idmesaexamen);
            }
          } else {
            this.MostrarMensaje("Error", result.data, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
      },
      async preguntamarcaimpresion (pdf, idmesa) {
        if (await this.$refs.confirm.open('Marcar como impresa', 'Desea marcar como impresa el acta una vez abierto el pdf?')) {
          const mesa = JSON.stringify({idmesa: idmesa, usuario: this.usuario});
          axios.post("examenfinal/PostMarcaImpresionActa", mesa, { headers: {"Content-Type": "application/json", }}).then((result) => {
            if (result.data.resultado === 0) {
              window.open(pdf, "_blank");
              this.actualizagrillamesas();
            }else{
              this.loading = false;
              window.open(pdf, "_blank");
            }
          }).catch(() => {
            this.loading = false;
            window.open(pdf, "_blank");
          });

        }else{
          this.loading = false;
          window.open(pdf, "_blank");
        }
      },
      fechaFormatoYMD(date) {
        return (date.getFullYear() + "-" + ((date.getMonth() + 1).toString().length != 2 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-" + (date.getDate().toString().length != 2 ? "0" + date.getDate() : date.getDate()));
      },
    },
    computed: {
      fechalocalfturnodesde: function () {
        if(this.turnoedited.desde!=null && this.turnoedited.desde!='')
        {
          var fecha=new Date(this.turnoedited.desde)
          fecha.setDate(fecha.getDate()+1)
          return fecha.toLocaleDateString('es-AR')
        }else{
          return ''
        }
      },
      fechalocalfturnohasta: function () {
        if(this.turnoedited.hasta!=null && this.turnoedited.hasta!='')
        {
          var fecha=new Date(this.turnoedited.hasta)
          fecha.setDate(fecha.getDate()+1)
          return fecha.toLocaleDateString('es-AR')
        }else{
          return ''
        }
      },
      fechalocalfmesa: function () {
        if(this.mesaedited.fecha!=null && this.mesaedited.fecha!='')
        {
          var fecha=new Date(this.mesaedited.fecha)
          fecha.setDate(fecha.getDate()+1)
          return fecha.toLocaleDateString('es-AR')
        }else{
          return ''
        }
      },
      fechalocalvenmesa: function () {
        if(this.mesaedited.vencimiento!=null && this.mesaedited.vencimiento!='')
        {
          var fecha=new Date(this.mesaedited.vencimiento)
          fecha.setDate(fecha.getDate()+1)
          return fecha.toLocaleDateString('es-AR')
        }else{
          return ''
        }
      },
    }
  }
</script>
<style>
.v-card__subtitle, .v-card__text, .v-card__title {
    padding: 4px;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    font-size: 0.680rem !important;
    height: 25px !important;
}

.textofilagrilla {
  font-size: 0.680rem !important;
  height: 5px !important;
}

.v-application--is-ltr .v-banner--is-mobile .v-banner__wrapper {
    padding-left: 1px !important;
}

.v-banner--is-mobile .v-banner__wrapper {
    flex-wrap: wrap;
    padding-top: 1px !important;
}

.v-application--is-ltr .v-banner__wrapper {
    padding: 1px 1px 1px 1px !important;
}

.letraroja {
  color: red;
}
.textocentrado {
  text-align: center;
}
.elementocentrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding: 2px !important;
}
@media only screen and (min-width: 960px) {
  .altojusto {
    height: 45px !important;
  }
}
.alineaizquierda {
  text-align: left;
}
.alineacentro {
  text-align: center;
}
.alineaderecha {
  text-align: right;
}
.ocupa30 {
  width: 30%;
}
.ocupa50 {
  width: 50%;
}
.ocupa75 {
  width: 75%;
}
.ocupa95 {
  width: 95%;
}
.centradovertical {
  vertical-align: middle;
  align-items: center;
}
.abajovertical {
  vertical-align: bottom;
}
.TituloGrilla {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkgray;
}
.textoNegritaRojo {
  color: red !important;
  font-weight: bold !important;
}
.textoNegritaVerde {
  color: rgb(83, 248, 125) !important;
  font-weight: bold !important;
}
.TituloGrillaNormal {
  font-family: Tahoma;
  font-size: large;
  font-weight: bold;
}
</style>